"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpaAddress = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const tpa_entity_1 = require("./tpa.entity");
const address_entity_1 = require("./address.entity");
const class_transformer_1 = require("class-transformer");
let TpaAddress = class TpaAddress {
};
exports.TpaAddress = TpaAddress;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id" }),
    tslib_1.__metadata("design:type", Number)
], TpaAddress.prototype, "tpaAddressId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "tpa_id" }),
    tslib_1.__metadata("design:type", Number)
], TpaAddress.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "address_id" }),
    tslib_1.__metadata("design:type", Number)
], TpaAddress.prototype, "addressId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => tpa_entity_1.Tpa, (tpa) => tpa.tpaAddresses, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "tpa_id" }),
    tslib_1.__metadata("design:type", Object)
], TpaAddress.prototype, "tpa", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => address_entity_1.Address, (address) => address.tpaAddresses, { eager: true }),
    (0, typeorm_1.JoinColumn)({ name: "address_id" }),
    tslib_1.__metadata("design:type", Object)
], TpaAddress.prototype, "address", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], TpaAddress.prototype, "deletedAt", void 0);
exports.TpaAddress = TpaAddress = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "tpa_address" })
], TpaAddress);
